import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.digitalWarehouse],
        config: {
            headerName: getLocalizedString("group"),
            field: "groupString",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.digitalWarehouse],
        config: {
            headerName: getLocalizedString("folder"),
            field: "folder",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.digitalWarehouse],
        config: {
            headerName: getLocalizedString("subfolder"),
            field: "sfolder",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.digitalWarehouse],
        config: {
            headerName: getLocalizedString("year"),
            field: "year",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.digitalWarehouse],
        config: {
            headerName: getLocalizedString("month"),
            field: "monthString",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.digitalWarehouse],
        config: {
            headerName: getLocalizedString("fileType"),
            field: "typeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.digitalWarehouse],
        config: {
            headerName: getLocalizedString("file"),
            field: "file",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.digitalWarehouse],
        config: {
            headerName: getLocalizedString("description"),
            field: "description",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.digitalWarehouse],
        config: {
            headerName: getLocalizedString("uploader"),
            field: "uploader",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.digitalWarehouse],
        config: {
            headerName: getLocalizedString("digitalFolderFechadecarga"),
            field: "dateUpload",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.digitalWarehouse],
        config: {
            headerName: getLocalizedString("digitalFolderHoradecarga"),
            field: "timeUpload",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.digitalWarehouse],
        config: {
            headerName: getLocalizedString("digitalFolderFechadevencimiento"),
            field: "expirationDate",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.digitalWarehouse],
        config: {
            headerName: getLocalizedString("groupMemberPermissions"),
            field: "permissionsString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.digitalWarehouse],
        config: {
            headerName: getLocalizedString("fileSyncStatus"),
            field: "syncStatusString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.myDigitalWarehouse],
        config: {
            headerName: getLocalizedString("folder"),
            field: "folder",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.myDigitalWarehouse],
        config: {
            headerName: getLocalizedString("subfolder"),
            field: "sfolder",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.myDigitalWarehouse],
        config: {
            headerName: getLocalizedString("year"),
            field: "year",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.myDigitalWarehouse],
        config: {
            headerName: getLocalizedString("month"),
            field: "monthString",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.myDigitalWarehouse],
        config: {
            headerName: getLocalizedString("fileType"),
            field: "typeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.myDigitalWarehouse],
        config: {
            headerName: getLocalizedString("file"),
            field: "file",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.myDigitalWarehouse],
        config: {
            headerName: getLocalizedString("description"),
            field: "description",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.myDigitalWarehouse],
        config: {
            headerName: getLocalizedString("digitalFolderFechadecarga"),
            field: "dateUpload",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.myDigitalWarehouse],
        config: {
            headerName: getLocalizedString("digitalFolderHoradecarga"),
            field: "timeUpload",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.myDigitalWarehouse],
        config: {
            headerName: getLocalizedString("digitalFolderFechadevencimiento"),
            field: "expirationDate",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.myDigitalWarehouse],
        config: {
            headerName: getLocalizedString("fileSyncStatus"),
            field: "syncStatusString",
            filter: "agSetColumnFilter",
        }
    },
]